import React from "react";
import first from "lodash/first";
import moment from "moment";

import { Typography } from "@mui/material";
import { GridRenderCellParams } from "@mui/x-data-grid-pro";
import { Stop } from "types";
import { useTimeFormat } from "globals/hooks/useTimeFormat";

function DateColumn(props: GridRenderCellParams<string>) {
  const { row } = props;
  const { formatDate } = useTimeFormat();

  const dateTime = first(row.stops as unknown as Stop[]).dateTime;
  const tripPickUpDate = formatDate(
    moment.utc(dateTime),
    false // Use numeric format for grid display
  );

  return <Typography variant="body2">{tripPickUpDate}</Typography>;
}

export default DateColumn;
